'use client'

import dynamic from 'next/dynamic'
import { useStore } from 'jotai'
import { lazy, Suspense, useEffect, useState } from 'react'
import { ClientOnly } from '@/features/shared/components/ClientOnly'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const DevOnlyJotaiDevTools =
  process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_DEV_TOOLS === 'true'
    ? dynamic(() => import('@/lib/jotaiDevTools').then((m) => ({ default: m.DevTools })), {
        ssr: false,
      })
    : null

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
)

const DynamicExperimentWidget = dynamic(
  () =>
    import('@/features/entrypoint/components/Developer/ExperimentWidget').then(
      (m) => m.ExperimentWidget,
    ),
  { ssr: false },
)

export const SegwayDevTools = () => {
  const jotaiStore = useStore()
  const [showRqDevtools, setShowRqDevtools] = useState(false)
  const [showExperimentDevtools, setShowExperimentDevtools] = useState(false)

  useEffect(() => {
    window.toggleRqDevTools = () => setShowRqDevtools((old) => !old)
    window.toggleExperimentDevTools = () => setShowExperimentDevtools((old) => !old)
  }, [])

  return (
    // all dev tools are client side only
    <ClientOnly>
      {!!DevOnlyJotaiDevTools && <DevOnlyJotaiDevTools store={jotaiStore} />}
      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition={DevOnlyJotaiDevTools ? 'top-left' : 'bottom-left'}
      />
      {!!showRqDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction buttonPosition="top-left" />
        </Suspense>
      )}
      {!!showExperimentDevtools && <DynamicExperimentWidget />}
    </ClientOnly>
  )
}
